import { render, staticRenderFns } from "./iti-router-view.vue?vue&type=template&id=351cf124&"
import script from "./iti-router-view.ts?vue&type=script&lang=ts&"
export * from "./iti-router-view.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports